import { fromDate } from 'sainsburys-date'

const getFinancialYear = ({ date }) => {
  const { year } = fromDate(date)
  return `${year.toString().substr(-2)}-${(year + 1).toString().substr(-2)}`
}

export default getFinancialYear
